"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    key: 0,
    class: "compose-overlay eh-popup-overlay"
};
var _hoisted_2 = { class: "field-row" };
var _hoisted_3 = { class: "field-value" };
var _hoisted_4 = { class: "provider-info" };
var _hoisted_5 = { class: "field-row" };
var _hoisted_6 = { class: "field-value" };
var _hoisted_7 = { class: "recipient-chip sms" };
var _hoisted_8 = { class: "recipient-name" };
var _hoisted_9 = {
    key: 0,
    class: "no-phone-hint"
};
var _hoisted_10 = { class: "char-info" };
var _hoisted_11 = {
    key: 0,
    class: "segment-count"
};
var _hoisted_12 = { class: "message-container" };
var _hoisted_13 = { class: "quick-templates" };
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
    key: 0,
    class: "send-error",
    role: "alert"
};
var _hoisted_16 = { class: "modal-footer" };
var _hoisted_17 = { class: "footer-right" };
var _hoisted_18 = ["disabled"];
var _hoisted_19 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning bi-arrow-clockwise bi-spin"
};
var _hoisted_20 = {
    key: 1,
    class: "glyphicon glyphicon-send bi-send"
};
var vue_3 = require("vue");
var smsApi_1 = require("@/api/smsApi");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SmsComposeModal',
    props: {
        show: { type: Boolean },
        patient: {},
        provider: {}
    },
    emits: ["close", "sent"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var modalRef = (0, vue_3.ref)(null);
        var textareaRef = (0, vue_3.ref)(null);
        var message = (0, vue_3.ref)('');
        var isSending = (0, vue_3.ref)(false);
        var sendError = (0, vue_3.ref)('');
        var position = (0, vue_3.reactive)({ x: 100, y: 100 });
        var dragOffset = (0, vue_3.reactive)({ x: 0, y: 0 });
        var isDragging = (0, vue_3.ref)(false);
        /*
        Right Now just a quick hard coded Array with nested objects
        * Later these response could be pulled from the back-end to truly make them dynamic
        */
        var quickTemplates = [
            { label: 'Appointment', text: 'Hi {name}, this is a reminder about your upcoming appointment. Reply YES to confirm or call us to reschedule.' },
            { label: 'Results', text: 'Hi {name}, your test results are ready. Please call our office or log into the patient portal to review them.' },
            { label: 'Follow-up', text: 'Hi {name}, we wanted to follow up on your recent visit. How are you feeling? Reply if you have any concerns.' },
            { label: 'Refill', text: 'Hi {name}, your prescription is ready for refill. Please contact our office if you have any questions.' }
        ];
        var charCount = (0, vue_3.computed)(function () { return message.value.length; });
        var segmentCount = (0, vue_3.computed)(function () { return Math.ceil(message.value.length / 160) || 1; });
        // The number the text goes to. Empty keeps Send off, and the To line says why.
        var recipientPhone = (0, vue_3.computed)(function () { var _a, _b; return String((_b = (_a = props.patient) === null || _a === void 0 ? void 0 : _a.phone) !== null && _b !== void 0 ? _b : '').trim(); });
        var canSend = (0, vue_3.computed)(function () { return message.value.trim().length > 0 && recipientPhone.value !== ''; });
        // Center modal on open
        (0, vue_3.watch)(function () { return props.show; }, function (show) {
            if (show && typeof window !== 'undefined') {
                position.x = Math.max(50, (window.innerWidth - 450) / 2);
                position.y = Math.max(50, (window.innerHeight - 450) / 2);
                message.value = '';
                sendError.value = '';
            }
        });
        function startDrag(e) {
            isDragging.value = true;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            dragOffset.x = clientX - position.x;
            dragOffset.y = clientY - position.y;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchmove', onDrag);
            document.addEventListener('touchend', stopDrag);
        }
        function onDrag(e) {
            if (!isDragging.value)
                return;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            position.x = Math.max(0, Math.min(clientX - dragOffset.x, window.innerWidth - 350));
            position.y = Math.max(0, Math.min(clientY - dragOffset.y, window.innerHeight - 100));
        }
        function stopDrag() {
            isDragging.value = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        }
        function updateCharCount() {
            // Auto-resize textarea
            if (textareaRef.value) {
                textareaRef.value.style.height = 'auto';
                textareaRef.value.style.height = Math.min(textareaRef.value.scrollHeight, 200) + 'px';
            }
        }
        function insertTemplate(text) {
            var patientName = props.patient ? props.patient.firstName : 'Patient';
            message.value = text.replace('{name}', patientName);
            updateCharCount();
        }
        function handleClose() {
            if (message.value.trim()) {
                if (!confirm('Discard this message?'))
                    return;
            }
            emit('close');
        }
        function handleSend() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!canSend.value || isSending.value)
                                return [2 /*return*/];
                            isSending.value = true;
                            sendError.value = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, (0, smsApi_1.sendTextMessage)(recipientPhone.value, message.value)];
                        case 2:
                            result = _a.sent();
                            if (!result.ok) {
                                sendError.value = result.message;
                                return [2 /*return*/];
                            }
                            emit('sent', { to: recipientPhone.value, message: message.value });
                            emit('close');
                            return [3 /*break*/, 4];
                        case 3:
                            isSending.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onUnmounted)(function () {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () {
                        var _a, _b, _c;
                        return [
                            (_ctx.show)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                                    (0, vue_2.createElementVNode)("div", {
                                        ref_key: "modalRef",
                                        ref: modalRef,
                                        class: "compose-modal sms-modal eh-popup-panel",
                                        style: (0, vue_2.normalizeStyle)({ left: position.x + 'px', top: position.y + 'px' })
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "modal-header",
                                            onMousedown: startDrag,
                                            onTouchstart: startDrag
                                        }, [
                                            _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", { class: "header-left" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment" }),
                                                (0, vue_2.createElementVNode)("h3", null, "New Text Message")
                                            ], -1)),
                                            (0, vue_2.createElementVNode)("div", { class: "header-actions" }, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "header-btn close",
                                                    title: "Close",
                                                    onClick: handleClose
                                                }, __spreadArray([], (_cache[1] || (_cache[1] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                                ])), true))
                                            ])
                                        ], 32),
                                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("label", null, "From:", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-earphone" }, null, -1)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.provider.phone) + " (" + (0, vue_2.toDisplayString)(_ctx.provider.name) + ") ", 1)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("label", null, "To:", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_7, [
                                                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, null, -1)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((_a = _ctx.patient) === null || _a === void 0 ? void 0 : _a.phone) + " ", 1),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)((_b = _ctx.patient) === null || _b === void 0 ? void 0 : _b.firstName) + " " + (0, vue_2.toDisplayString)((_c = _ctx.patient) === null || _c === void 0 ? void 0 : _c.lastName), 1)
                                                ]),
                                                (!recipientPhone.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_9, "No phone number on file"))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(["char-count", { warning: charCount.value > 140, danger: charCount.value > 160 }])
                                            }, (0, vue_2.toDisplayString)(charCount.value) + " / 160 characters ", 3),
                                            (segmentCount.value > 1)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, (0, vue_2.toDisplayString)(segmentCount.value) + " SMS segments ", 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                                ref_key: "textareaRef",
                                                ref: textareaRef,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((message).value = $event); }),
                                                class: "message-input",
                                                placeholder: "Type your message...",
                                                onInput: updateCharCount
                                            }, null, 544), [
                                                [vue_2.vModelText, message.value]
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("span", { class: "templates-label" }, "Quick:", -1)),
                                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(quickTemplates, function (template) {
                                                    return (0, vue_2.createElementVNode)("button", {
                                                        key: template.label,
                                                        class: "template-btn",
                                                        onClick: function ($event) { return (insertTemplate(template.text)); }
                                                    }, (0, vue_2.toDisplayString)(template.label), 9, _hoisted_14);
                                                }), 64))
                                            ])
                                        ]),
                                        (sendError.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, (0, vue_2.toDisplayString)(sendError.value), 1))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                            _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("div", { class: "footer-left" }, null, -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-cancel",
                                                    onClick: handleClose
                                                }, "Cancel"),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-send",
                                                    onClick: handleSend,
                                                    disabled: !canSend.value || isSending.value
                                                }, [
                                                    (isSending.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_20)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isSending.value ? 'Sending...' : 'Send SMS'), 1)
                                                ], 8, _hoisted_18)
                                            ])
                                        ])
                                    ], 4)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ];
                    }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
